export const productShortName = 'Climate Science & Climate Change — Teacher Ready';
export const productBrand = 'Climate Science & Climate Change';
export const productEdition = 'Teacher Ready';
export const productImage = 'https://cdn.magicpatterns.com/uploads/naC2vxBFdPh28eebn3VpTw/MOCKUP_CLIMATE.png';
export const productImageAlt =
  'Climate Science & Climate Change Teacher Ready: a 6-volume teaching collection covering the atmosphere and energy balance, oceans, ice and cycles, climate history, evidence and models, impacts, and solutions and teaching, plus 5 bonus resources';

export const checkoutUrl = 'https://climate-science-climate-change.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusValue = 'USD 14.00';
export const bonusTotalValue = 'USD 70.00';

export const closingLines = [
  'No more building every climate lesson from scratch',
  'No more hunting for diagrams and data you can trust',
  'No more confusion between weather and climate, or the greenhouse effect and the ozone hole',
  'No more confusing headlines without clear evidence to discuss in class',
  'No more improvising activities to complete your climate unit',
];
